import { Component, OnInit } from '@angular/core';
import { Organization } from 'src/app/models';
import { OrganizationService } from 'src/app/services';

@Component({
  selector: 'app-sidebar-dashboard',
  templateUrl: './sidebar-dashboard.component.html',
  styleUrls: ['./sidebar-dashboard.component.css']
})
export class SidebarDashboardComponent implements OnInit {

  toggleOpen: boolean = false;
  org: Organization;

  constructor(private _organizationService: OrganizationService) { }

  ngOnInit(): void {
    if (!this._organizationService.organization) {
      this._organizationService.getCurrentOrg(false).subscribe(
        (res: Organization) => this.org = res,
      )
    } else {
      this.org = this._organizationService.organization
    }
  }

}
